import { FEATURE_FLAG } from '~/constants/featureFlags';

import { type RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  disablingFeatureFlag: FEATURE_FLAG.DISABLE_INVOICES,
  featureFlag: FEATURE_FLAG.MANUAL_INVOICE_CHECKING_PIPELINE,
  permissions: ['invoice.'],
};
